// import React from 'react';
// import Tree from 'react-d3-tree';
// import '../tree_views/horizontal_tree.css';
// import { useSharedValue } from '../components/Constants/constants';

// const styles = {
//   nodes: {
//     node: {
//       circle: {
//         fill: "yellow",
//       },
//     },
//     leafNode: {
//       circle: {
//         fill: "#0288d1",
//       },
//       text: {
//         fontSize: "14px",
//         fontWeight: "400",
//         width:'100px',

//       },
//     },
//   },
// };
// const truncateText = (text, maxWidth) => {
//   const canvas = document.createElement("canvas");
//   const context = canvas.getContext("2d");
//   context.font = "12px Arial"; // Match the font used in your SVG text
//   let ellipsis = "...";
//   let width = context.measureText(text).width;

//   if (width <= maxWidth) {
//     return text; // Text fits within the width
//   }

//   // Reduce the text length and append ellipsis until it fits
//   while (width > maxWidth && text.length > 0) {
//     text = text.slice(0, -1);
//     width = context.measureText(text + ellipsis).width;
//   }

//   return text + ellipsis;
// };

// const maxWidth = 100; // Set max width for text

// const OrganizationChartManager = ({ data }) => {
//   const {treeView} = useSharedValue();
//   // Custom node rendering
//   const renderCustomNodeElement = ({ nodeDatum }) => {

//     return(
//     <g>
//       <circle
//         r="12"
//         className={nodeDatum.children && nodeDatum.children.length > 0 ? "node-yellow" : "node-blue"}
//       />
//       <text fill="black" strokeWidth="0.5" x="20" dy="0.35em">
//       <tspan>
//         {truncateText(nodeDatum.name, maxWidth)}
//       </tspan>

//        {/* // */}
//         {nodeDatum.attributes && (
//           <>
//             {Object.entries(nodeDatum.attributes).map(([key, value]) => (
//               <tspan key={key} x="20" dy="1.2em">
//                {truncateText(`${key}: ${value}`, maxWidth)}
//               </tspan>
//             ))}
//           </>
//         )}
//       </text>
//     </g>)
//   };

//   return (
//     <div style={{ width: '100%', height: '500px' }}>
//       <Tree
//         data={data}
//         orientation={treeView}
//         translate={{ x: 200, y: 50 }}
//         nodeSize={{ x: 200, y: 100 }}
//         renderCustomNodeElement={renderCustomNodeElement}
//         separation={{ siblings: 0.8, nonSiblings: 0.8 }}
//         styles={styles}
//       />
//     </div>
//   );
// };

// export default OrganizationChartManager;

// import React from "react";
// import Tree from "react-d3-tree";
// import "../tree_views/horizontal_tree.css";
// import { useSharedValue } from "../components/Constants/constants";

// const styles = {
//   nodes: {
//     node: {
//       circle: {
//         fill: "yellow",
//       },
//     },
//     leafNode: {
//       circle: {
//         fill: "#0288d1",
//       },
//       text: {
//         fontSize: "14px",
//         fontWeight: "400",
//       },
//     },
//   },
// };

// const svgSquare = {
//   shape: 'rect',
//   shapeProps: {
//     width: 0,
//     height: 0,
//   }
// }
// const OrganizationChartManager = ({ data }) => {
//   const truncateText = (text, maxWidth, fontSize) => {
//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");
//     context.font = `${fontSize}px sans-serif`;

//     let truncatedText = text;
//     while (context.measureText(truncatedText).width > maxWidth) {
//       truncatedText = truncatedText.slice(0, -1);
//     }

//     return truncatedText.length < text.length ? `${truncatedText}...` : truncatedText;
//   };
//   const maxWidth = 100;

//   const { treeView } = useSharedValue();

//   const renderCustomNodeElement = ({ nodeDatum }) => {
//     const truncatedName = truncateText(nodeDatum.name, maxWidth, 14);

//     return (
//       <g>
//         <circle
//           r="12"
//           className={nodeDatum.children && nodeDatum.children.length > 0 ? "node-yellow" : "node-blue"}
//         />
//         <text  fontWeight='300' fontSize='14' strokeWidth="0.5" x={treeView == 'horizontal' ?"-20" : "20"} y={treeView == 'horizontal' ? "20" : "0" } dy="0.35em">
//           <tspan>{truncatedName}</tspan>
//           {nodeDatum.attributes &&
//             Object.entries(nodeDatum.attributes).map(([key, value]) => (
//               <tspan key={key} x={treeView == 'horizontal' ?"-20" : "20"} y={treeView == 'horizontal' ? "20" : "0" } dy="1.2em">
//                 {truncateText(`${key}: ${value}`, maxWidth, 13)}
//               </tspan>
//             ))}
//         </text>
//       </g>
//     );
//   };

//   return (
//     <div style={{ width: "100%", height: "100%", display:'flex', alignItems:'center', justifyContent:'center', position: "relative", }}>
//       <Tree
//         data={data}
//         allowForeignObjects
//         orientation= {treeView}
//         // translate={{ x: 200, y: 100 }}
//         nodeSize={{ x: 200, y: 100 }}
//         renderCustomNodeElement={renderCustomNodeElement}
//         separation={{ siblings: 0.8, nonSiblings: 0.8 }}
//         styles={styles}
//         pathFunc="step" // Optional: Adjust the path style
//         depthFactor={treeView == 'inversion'? -100 : 0}
//       />
//     </div>
//   );
// };

// export default OrganizationChartManager;

// import React, { useState, useEffect } from "react";
// import Tree from "react-d3-tree";
// import "../tree_views/horizontal_tree.css";
// import { useSharedValue } from "../components/Constants/constants";
// import { colors } from "@mui/material";

// const styles = {
//   nodes: {
//     node: {
//       circle: {
//         fill: "yellow",
//       },
//     },
//     leafNode: {
//       circle: {
//         fill: "#0288d1",
//       },
//       text: {
//         fontSize: "14px",
//         fontWeight: "400",
//       },
//     },
//   },
// };

// const OrganizationChartManager = ({ data }) => {
//   const truncateText = (text, maxWidth, fontSize) => {
//     const canvas = document.createElement("canvas");
//     const context = canvas.getContext("2d");
//     context.font = `${fontSize}px sans-serif`;

//     let truncatedText = text;
//     while (context.measureText(truncatedText).width > maxWidth) {
//       truncatedText = truncatedText.slice(0, -1);
//     }

//     return truncatedText.length < text.length ? `${truncatedText}...` : truncatedText;
//   };

//   const maxWidth = 100;

//   const { treeView } = useSharedValue();

//   const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

//   const formTypeColors = {
//     "W-9": "#ff5722", // Orange
//     "W-8BEN": "#4caf50", // Green
//     "w-8BEN-E": "#2196f3", // Blue
//     "w-8ECI": "#9c27b0", // Purple
//     default: "#2196f3", // Default Gray
//   };

//   // Get the color based on formType or use default

//   useEffect(() => {
//     // Get parent container's dimensions
//     const updateDimensions = () => {
//       const container = document.getElementById("tree-container");
//       setDimensions({
//         width: container.offsetWidth,
//         height: container.offsetHeight,
//       });
//     };

//     updateDimensions();
//     window.addEventListener("resize", updateDimensions);

//     return () => window.removeEventListener("resize", updateDimensions);
//   }, []);

//   const renderCustomNodeElement = ({ nodeDatum }) => {
//     const truncatedName = truncateText(nodeDatum.name, maxWidth, 14);

//     return (
//       <g>
//         <circle
//           r="12"
//           className={nodeDatum.children && nodeDatum.children.length > 0 ? "node-yellow" : "node-blue"}
//         />
//         <text
//           fontWeight="300"
//           fontSize="14"

//           strokeWidth="0.5"
//           x={treeView === "horizontal" ? "-20" : "20"}
//           y={treeView === "horizontal" ? "20" : "0"}
//           dy="0.35em"
//         >
//           <tspan>{truncatedName}</tspan>
//           {nodeDatum.attributes && (
//             // Object.entries(nodeDatum.attributes).map(([key, value]) => (
//             //   <tspan
//             //     key={key}
//             //     x={treeView === "horizontal" ? "-20" : "20"}
//             //     y={treeView === "horizontal" ? "20" : "0"}
//             //     dy="1.2em"
//             //   >
//             //     {truncateText(`${key}: ${value}`, maxWidth, 13)}
//             //   </tspan>
//             // ))
//             <>
//               {nodeDatum.attributes.allocation && (
//                 <tspan
//                   x={treeView === "horizontal" ? "-20" : "20"}
//                   dy="1.2em"
//                 >
//                   {truncateText(`Allocation: ${nodeDatum.attributes.allocation}`, maxWidth, 13)}
//                 </tspan>
//               )}
//               {nodeDatum.attributes.formType && (
//                 <tspan
//                   style={{ fill: formTypeColors[nodeDatum.attributes?.formType] || formTypeColors.default }}

//                   x={treeView === "horizontal" ? "-20" : "20"}
//                   dy="1.2em"
//                 >
//                   {truncateText(`Form: ${nodeDatum.attributes.formType}`, maxWidth, 13)}
//                 </tspan>
//               )}
//             </>

//           )}
//         </text>

//       </g>
//     );
//   };

//   return (
//     <div
//       id="tree-container"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "relative",
//       }}
//     >
//       {dimensions.width && dimensions.height && (
//         <Tree
//           data={data}
//           allowForeignObjects
//           orientation={treeView}
//           translate={{
//             x: dimensions.width / 2,
//             y: dimensions.height / 3,
//           }}
//           nodeSize={{ x: 200, y: 100 }}
//           renderCustomNodeElement={renderCustomNodeElement}
//           separation={{ siblings: 0.8, nonSiblings: 0.8 }}
//           styles={styles}
//           pathFunc="step"
//           depthFactor={treeView === "inversion" ? -100 : 0}
//         />
//       )}
//     </div>
//   );
// };

// export default OrganizationChartManager;

import React, { useEffect, useState } from "react";
import Tree from "react-d3-tree";
import "../tree_views/horizontal_tree.css";
import { useSharedValue } from "../components/Constants/constants";

const NODE_WIDTH = 200;
const NODE_HEIGHT = 90;

const NodeCard = ({ nodeDatum }) => {
  const name = nodeDatum?.name || "";
  const code = nodeDatum?.attributes?.number || nodeDatum?.attributes?.code || "";
  const allocation = nodeDatum?.attributes?.allocation || "";

  return (
    <div
      // eslint-disable-next-line react/no-unknown-property
      xmlns="http://www.w3.org/1999/xhtml"
      style={{
        width: NODE_WIDTH,
        background: "white",
        borderRadius: 10,
        border: "1px solid #e4eef7",
        boxShadow: "none",
        padding: "8px 10px",
        fontFamily: "Inter, sans-serif",
        boxSizing: "border-box",
      }}
    >
      {/* Name */}
      <div
        title={name}
        style={{
          fontWeight: 700,
          fontSize: 13,
          color: "#1a1a2e",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          marginBottom: code || allocation ? 6 : 0,
          lineHeight: 1.3,
        }}
      >
        {name}
      </div>

      {/* Code + Allocation row */}
      {(code || allocation) && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
          {code && (
            <span
              style={{
                fontSize: 11,
                color: "#667085",
                background: "#F2F4F7",
                borderRadius: 6,
                padding: "2px 8px",
                whiteSpace: "nowrap",
              }}
            >
              {code}
            </span>
          )}
          {allocation && (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 3,
                background: "var(--dev-alloc-bg)",
                borderRadius: 6,
                padding: "2px 8px",
                fontSize: 11,
                color: "var(--dev-alloc-text)",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              $ Allocation: {allocation}%
            </span>
          )}
        </div>
      )}
    </div>
  );
};

const OrganizationChartManager = ({ data }) => {
  const { treeView } = useSharedValue();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      const container = document.getElementById("tree-container");
      if (container) {
        setDimensions({
          width: container.offsetWidth,
          height: container.offsetHeight,
        });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const renderCustomNodeElement = ({ nodeDatum }) => (
    <foreignObject
      x={-(NODE_WIDTH / 2)}
      y={-(NODE_HEIGHT / 2)}
      width={NODE_WIDTH}
      height={NODE_HEIGHT + 60}
      style={{ overflow: "visible" }}
    >
      <NodeCard nodeDatum={nodeDatum} />
    </foreignObject>
  );

  return (
    <div
      id="tree-container"
      style={{
        width: "100%",
        height: "100%",
        background: "var(--dev-viz-bg)",
        borderRadius: 8,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {dimensions.width > 0 && dimensions.height > 0 && (
        <Tree
          data={data}
          allowForeignObjects
          orientation={treeView || "vertical"}
          translate={{
            x: dimensions.width / 2,
            y: NODE_HEIGHT + 20,
          }}
          scaleExtent={{ min: 0.2, max: 2 }}
          nodeSize={{ x: NODE_WIDTH + 60, y: NODE_HEIGHT + 50 }}
          renderCustomNodeElement={renderCustomNodeElement}
          separation={{ siblings: 1.0, nonSiblings: 1.2 }}
          pathFunc="step"
          pathClassFunc={() => "custom-line-style rd3t-link"}
        />
      )}
    </div>
  );
};

export default OrganizationChartManager;
